// App-wide shared state: preferences, audio engine, lightweight pub/sub, toasts.

import { AudioEngine } from '../audio/engine';
import { loadPreferences, savePreferences, DEFAULT_PREFERENCES } from '../storage/preferences';
import type { UserPreferences } from '../types';

type Listener = () => void;

class AppState {
  prefs: UserPreferences = loadPreferences();
  engine = new AudioEngine(this.prefs);
  online = navigator.onLine;
  private listeners = new Set<Listener>();

  constructor() {
    window.addEventListener('online', () => this.setOnline(true));
    window.addEventListener('offline', () => this.setOnline(false));
  }

  setPrefs(patch: Partial<UserPreferences>): void {
    this.prefs = { ...this.prefs, ...patch };
    savePreferences(this.prefs);
    this.engine.updatePreferences(this.prefs);
    this.emit();
  }

  resetPrefs(): void {
    this.setPrefs({ ...DEFAULT_PREFERENCES });
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }

  private emit(): void {
    for (const l of this.listeners) l();
  }

  private setOnline(v: boolean): void {
    this.online = v;
    this.emit();
  }
}

export const state = new AppState();

// ---- Toast ----
let toastEl: HTMLDivElement | null = null;
let toastTimer: number | null = null;
export function toast(msg: string, ms = 2200): void {
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.className = 'toast';
    document.body.appendChild(toastEl);
  }
  toastEl.textContent = msg;
  toastEl.style.opacity = '1';
  if (toastTimer) window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => {
    if (toastEl) toastEl.style.opacity = '0';
  }, ms);
}
